import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/loaderSlice";
import toastReducer from "./slices/toastSlice";
import userSlice from "./slices/userSlice";
import servicesReducer from "./slices/servicesSlice";
import ordersReducer from "./slices/ordersSlice";
import dashboardReducer from "./slices/dashboardSlice";
import asyncDispatchMiddleware from "./asyncDispatchMiddleware";
import contentSlice from "./slices/contentSlice";
import stageSmartSlice from "./slices/stageSmartSlice";
import contactReducer from "./slices/contactSlice";

export const store = configureStore({
  reducer: {
    loader: authReducer,
    toast: toastReducer,
    user: userSlice,
    service: servicesReducer,
    order: ordersReducer,
    dashboard: dashboardReducer,
    content: contentSlice,
    stageSmart: stageSmartSlice,
    contact:contactReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(asyncDispatchMiddleware),
});
